﻿(function (d, ns) {
    ns.initMobileNavigation = function () {
        const animationDuration = 300;
        let isAnimating = false;

        const $navBar = d.querySelector('.drilldown-menu-nav');

        if ($navBar == null || typeof $navBar == undefined) {
            return;
        }

        const $title = $navBar.querySelector('.navigation_drilldownMenuCurrentMenuItem');
        const $backButton = $navBar.querySelector('.navigation__drilldownMenuBack');

        function toggleSubmenu(drilldownSelector, titleText) {
            if (isAnimating) {
                return;
            }

            isAnimating = true;
            const $submenu = d.querySelector(drilldownSelector);

            if ($submenu.classList.contains('active')) {
                $backButton.style.display = 'none';
                $title.textContent = '';
                d.querySelector('.mobile-navigation__container').classList.remove('slide-out');
                $submenu.classList.remove('active');
            } else {
                const activeDropdown = d.querySelector('.mobile-navigation__dropdown.active');
                if (activeDropdown) {
                    activeDropdown.classList.remove('active');
                }
                $submenu.classList.add('active');
                $backButton.style.display = 'block';

                $title.textContent = titleText;
                d.querySelector('.mobile-navigation__container').classList.add('slide-out');
            }

            setTimeout(function () {
                isAnimating = false;
            }, animationDuration);
        }

        const menuItems = d.querySelectorAll('.mobile-navigation__item[data-drilldown-menu]');
        menuItems.forEach(function (menuItem) {
            menuItem.addEventListener('click', function () {
                const drilldownSelector = this.getAttribute('data-drilldown-menu');
                const titleText = this.textContent;
                toggleSubmenu(drilldownSelector, titleText);
            });
        });

        $backButton.addEventListener('click', function () {
            toggleSubmenu('.mobile-navigation__dropdown.active', '');
        });
    };

    d.addEventListener('DOMContentLoaded', function () {
        ns.initMobileNavigation();
    });
})(document, Crafted.Utilities);